import AdminDialogController from "../admin_controllers/dialog_controller";
import { initAdminDialogLinks } from "../packs/admin_dialog_links";

// Admin tools embedded in public pages retain the admin dialog lifecycle.
export default class extends AdminDialogController {
  async connect() {
    const { Turbo } = await import("@hotwired/turbo-rails");
    if (!this.element.isConnected) return;
    Turbo.session.drive = false;
    initAdminDialogLinks();
    super.connect();
  }

  openDialogHtml(html, button) {
    const template = document.createElement("template");
    template.innerHTML = html;
    template.content.querySelectorAll("[data-controller], [data-dialog-target], [data-action]").forEach(element => {
      if (element.hasAttribute("data-controller")) {
        element.dataset.controller = element.dataset.controller.replace(/\bdialog\b/g, "admin-dialog");
      }
      if (element.hasAttribute("data-dialog-target")) {
        element.setAttribute("data-admin-dialog-target", element.dataset.dialogTarget);
        element.removeAttribute("data-dialog-target");
      }
      if (element.hasAttribute("data-action")) {
        element.dataset.action = element.dataset.action.replace(/\bdialog#/g, "admin-dialog#");
      }
    });
    super.openDialogHtml(template.innerHTML, button);
  }
}
